import React from "react";
import styled from 'styled-components';
import Ticker from 'react-ticker';

import { calc4k } from '../utilities';
import alertBG from '../data/images/alert-bg.svg';

import Marquee from './Marquee';

export default function({ active, message, speed }) {

    return (
        <Alert active={active}>
            {
                active && message && message.length >= 80 ? (
                    <Marquee message={message} active={active} speed={speed}/>
                ) : ( message ? <span>{message}</span> : null )
            }
        </Alert>
    );
    // return (
    //     <Alert active={active}>
    //         {
    //             message && message.length >= 80 ? (
    //                 <Ticker speed={speed || 15} mode={'smooth'} offset={'50%'}>
    //                     {({ index }) => (
    //                         <TickerText>
    //                             {message}
    //                         </TickerText>
    //                     )}
    //                 </Ticker>
    //             ) : ( message ? <span>{message}</span> : null )
    //         }
    //     </Alert>
    // );
}

const Alert = styled.div`
    padding: ${p => p.active ? `${calc4k(80)} 0` : 0 };
    max-height: ${p => p.active ? calc4k(200) : 0 };
    transition: max-height 1200ms ease, padding 1200ms ease;
    background-image: url(${alertBG});
    background-size: cover;
    background-position: center;
    color: #fbebcb;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${calc4k(50)};
    font-weight: 500;
    overflow: hidden;
    box-sizing: border-box;
    
    .ticker {
        width: 100%;
        white-space: nowrap;
    }
`;

const TickerText = styled.div`
    display: inline-block;
    box-sizing: border-box;
    
    &::after {
        display: inline-block;
        content: '•';
        box-sizing: border-box;
        padding: 0 ${calc4k(25)};
    }
`;